'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const universal_color = require('../../style/universal.color.js');
const icon = require('../Icon/icon.js');
const image = require('../Image/image.js');
const spot_style = require('./spot.style.js');
const headshot_types = require('../Headshot/headshot.types.js');
const headshot = require('../Headshot/headshot.js');
const spot_types = require('./spot.types.js');

var Spot = function Spot(_ref) {
  var alt = _ref.alt,
    className = _ref.className,
    id = _ref.id,
    isFavorite = _ref.isFavorite,
    _ref$lazyload = _ref.lazyload,
    lazyload = _ref$lazyload === void 0 ? true : _ref$lazyload,
    _ref$spotSource = _ref.spotSource,
    spotSource = _ref$spotSource === void 0 ? headshot_types.HeadshotTypes.SPOTS : _ref$spotSource,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? spot_types.SpotType.TEAM : _ref$type,
    width = _ref.width;
  var spotWidth = +width;
  var favIconWidth = Math.floor(spotWidth * 0.42);
  var spotComponent = null;
  if (type === spot_types.SpotType.PLAYER) {
    spotComponent = /*#__PURE__*/React__default.createElement(headshot.default, {
      src: "",
      playerId: id,
      alt: alt,
      lazyload: lazyload,
      type: spotSource,
      width: spotWidth,
      ratio: "1:1"
    });
  } else {
    var imageType = Object.values(spot_types.SpotType).includes(type) ? type : 'sport';
    var srcset = React.useMemo(function () {
      return {
        '1x': "https://midfield.mlbstatic.com/v1/".concat(imageType, "/").concat(id, "/spots/").concat(spotWidth),
        '2x': "https://midfield.mlbstatic.com/v1/".concat(imageType, "/").concat(id, "/spots/").concat(spotWidth * 2),
        '3x': "https://midfield.mlbstatic.com/v1/".concat(imageType, "/").concat(id, "/spots/").concat(spotWidth * 3)
      };
    }, [id, imageType, spotWidth]);
    spotComponent = /*#__PURE__*/React__default.createElement(image.default, {
      alt: alt,
      lazyload: lazyload,
      placeHolderHeight: spotWidth,
      placeHolderWidth: spotWidth,
      src: srcset['3x'],
      srcset: srcset
    });
  }
  return /*#__PURE__*/React__default.createElement(spot_style.SpotContainer, {
    "data-size": spotWidth,
    className: className
  }, isFavorite && /*#__PURE__*/React__default.createElement(spot_style.FavIconContainer, {
    "data-size": favIconWidth
  }, /*#__PURE__*/React__default.createElement(icon, {
    name: "favorite",
    fill: universal_color.favoriteYellow,
    width: favIconWidth
  })), spotComponent);
};

module.exports = Spot;
